const GROUP_GAP_SPACING = 3;
const HEADING_GAP_SPACING = 1.5;

export const groupStyles = {
  '&:not(:first-of-type)': {
    marginTop: ({ spacing }) => spacing(GROUP_GAP_SPACING),
  },
};

export const groupHeadingStyles = {
  display: 'flex',
  alignItems: 'baseline',
  gap: ({ spacing }) => spacing(HEADING_GAP_SPACING),
  marginBottom: ({ spacing }) => spacing(1),
};

export const groupHeadingLabelStyles = {
  wordBreak: 'break-word',
};

export const groupProgressStyles = {
  whiteSpace: 'nowrap',
};
